import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import AntdTable from "../../antd/Table/Table";
import { useGetAllTasksQuery } from "../../../Redux/service/Tasks/Tasks";
import useAlertData from "../../../hooks/useAlertData";
import {
  useGetAbsentIdleStaffQuery,
  useGetFormMetricsQuery,
  useGetTaskAlertsQuery,
  useGetTaskDistributionByStatusQuery,
} from "../../../Redux/service/Dashboard";
import {
  useGetAllRequestsQuery,
  useGetRequestsByStatusQuery,
} from "../../../Redux/service/Requests/Request";
import { useGetAllTechnicianQuery } from "../../../Redux/service/Technician/Technician";
import { useGetSlaViolationQuery } from "../../../Redux/service/fsm/FSMDashboard";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import trans, { isRTL } from "../../../utils";

const apiHooks = {
  useGetAllTasksQuery,
  useGetAbsentIdleStaffQuery,
  useGetAllRequestsQuery,
  useGetAllTechnicianQuery,
  useGetFormMetricsQuery,
  useGetTaskAlertsQuery,
  useGetSlaViolationQuery,
  useGetTaskDistributionByStatusQuery,
  useGetRequestsByStatusQuery,
};

const AlertPopup = ({ onClose, alert }) => {
  const useApi = apiHooks[alert.api];
  const {
    data: apiResponse,
    isLoading,
    params,
    onPageChange,
    onLimitChange,
    error,
  } = useAlertData(useApi, alert.query);
  let extractedData = [];
  if (alert.extractData && typeof alert.extractData === "function") {
    extractedData = alert.extractData(apiResponse);
  } else {
    extractedData = apiResponse?.data || [];
  }

  if (alert.frontendFilter && typeof alert.frontendFilter === "function") {
    extractedData = alert.frontendFilter(extractedData);
  }

  const totalItems = alert.extractTotal(apiResponse) || 0;

  if (!alert) return null;
  return (
    <Popup show={!!alert}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle
            headtitle={alert?.title}
            subtitle={alert?.tooltip}
            nospace={true}
          />
        </Modal.Title>
        <Close style="close-32 close" close={() => onClose()} img="Close" />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        {alert?.link && (
          <div className={`${isRTL ? "text-start" : "text-end"} mb-8`}>
            <a href={`${process.env.PUBLIC_URL}/${alert?.link}`}>
              <p className="fs-14 neutral-500 mb-0 pointer">
                {trans("For More Details")}{" "}
                {isRTL ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
              </p>
            </a>
          </div>
        )}
        <AntdTable
          columns={alert.columns}
          dataSource={extractedData}
          loading={isLoading}
          pageSize={params.limit}
          totalItems={totalItems}
          currentPage={params.page}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          scrollY={300}
          empty
        />
      </Modal.Body>
    </Popup>
  );
};

export default AlertPopup;
